import { Pipe, PipeTransform } from '@angular/core';

import { AirFilterTabsResponse } from '@shared/filters/entities/fetch-filters.response';
import { FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { SorterTypes } from '@shared/filters/entities/sorter-options';
import { AirFilterResponseVm, AirFilterVm } from '@shared/magic-filter-bar/entities/filter-types';

@Pipe({
  name: 'airSorterTabs',
  standalone: false
})
export class AirSorterTabsPipe implements PipeTransform {

  transform(filters: AirFilterResponseVm, ...args: string[]): AirFilterVm {
    const filter = filters[FilterTypes.AirFilterTabs] || [];
    const value = filter?.map((sorter: AirFilterTabsResponse) => ({
      ...sorter,
      order: sorter.OrderCriteria === SorterTypes.Recommended ? 1 : 0
    })).sort((sorterA, sorterB) => sorterB.order - sorterA.order);
    return {
      type: FilterTypes.AirFilterTabs,
      filter: undefined,
      value: value
    };
  }
}
